/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import { useMutation } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from "@tanstack/react-query";
import { httpClient } from "../../orval/http-client";
import type { ErrorType, BodyType } from "../../orval/http-client";
import type {
  AuthImpersonateRequest,
  AuthLoginRequest,
  AuthRegisterRequest,
  AuthResponse,
  AuthSendEmailVerificationRequest,
  AuthSendOttRequest,
  AuthSendPasswordResetRequest,
  AuthSendPhoneVerificationRequest,
  ErrorResponse,
  PasswordResetEndAction,
  VerifyRequestEndAction,
} from "../model";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const updatePassword = (
  passwordResetEndAction: BodyType<PasswordResetEndAction>,
  options?: SecondParameter<typeof httpClient>,
  signal?: AbortSignal,
) => {
  return httpClient<AuthResponse>(
    {
      url: `/auth/verify/reset_password`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: passwordResetEndAction,
      signal,
    },
    options,
  );
};

export const getUpdatePasswordMutationKey = () => ["updatePassword"] as const;

export const getUpdatePasswordMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePassword>>,
    TError,
    UpdatePasswordMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updatePassword>>,
  TError,
  UpdatePasswordMutationVariables,
  TContext
> => {
  const mutationKey = getUpdatePasswordMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updatePassword>>,
    UpdatePasswordMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return updatePassword(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdatePasswordMutationResult = NonNullable<
  Awaited<ReturnType<typeof updatePassword>>
>;
export type UpdatePasswordMutationBody = BodyType<PasswordResetEndAction>;
export type UpdatePasswordMutationError = ErrorType<ErrorResponse>;
export type UpdatePasswordMutationVariables = {
  data: BodyType<PasswordResetEndAction>;
};

export const useUpdatePassword = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updatePassword>>,
      TError,
      UpdatePasswordMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updatePassword>>,
  TError,
  UpdatePasswordMutationVariables,
  TContext
> => {
  return useMutation(getUpdatePasswordMutationOptions(options), queryClient);
};
export const verifyPhone = (
  verifyRequestEndAction: BodyType<VerifyRequestEndAction>,
  options?: SecondParameter<typeof httpClient>,
  signal?: AbortSignal,
) => {
  return httpClient<AuthResponse>(
    {
      url: `/auth/verify/phone_verification`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: verifyRequestEndAction,
      signal,
    },
    options,
  );
};

export const getVerifyPhoneMutationKey = () => ["verifyPhone"] as const;

export const getVerifyPhoneMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof verifyPhone>>,
    TError,
    VerifyPhoneMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof verifyPhone>>,
  TError,
  VerifyPhoneMutationVariables,
  TContext
> => {
  const mutationKey = getVerifyPhoneMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof verifyPhone>>,
    VerifyPhoneMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return verifyPhone(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type VerifyPhoneMutationResult = NonNullable<
  Awaited<ReturnType<typeof verifyPhone>>
>;
export type VerifyPhoneMutationBody = BodyType<VerifyRequestEndAction>;
export type VerifyPhoneMutationError = ErrorType<unknown>;
export type VerifyPhoneMutationVariables = {
  data: BodyType<VerifyRequestEndAction>;
};

export const useVerifyPhone = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof verifyPhone>>,
      TError,
      VerifyPhoneMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof verifyPhone>>,
  TError,
  VerifyPhoneMutationVariables,
  TContext
> => {
  return useMutation(getVerifyPhoneMutationOptions(options), queryClient);
};
export const verifyOtt = (
  verifyRequestEndAction: BodyType<VerifyRequestEndAction>,
  options?: SecondParameter<typeof httpClient>,
  signal?: AbortSignal,
) => {
  return httpClient<AuthResponse>(
    {
      url: `/auth/verify/mfa_verification`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: verifyRequestEndAction,
      signal,
    },
    options,
  );
};

export const getVerifyOttMutationKey = () => ["verifyOtt"] as const;

export const getVerifyOttMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof verifyOtt>>,
    TError,
    VerifyOttMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof verifyOtt>>,
  TError,
  VerifyOttMutationVariables,
  TContext
> => {
  const mutationKey = getVerifyOttMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof verifyOtt>>,
    VerifyOttMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return verifyOtt(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type VerifyOttMutationResult = NonNullable<
  Awaited<ReturnType<typeof verifyOtt>>
>;
export type VerifyOttMutationBody = BodyType<VerifyRequestEndAction>;
export type VerifyOttMutationError = ErrorType<ErrorResponse>;
export type VerifyOttMutationVariables = {
  data: BodyType<VerifyRequestEndAction>;
};

export const useVerifyOtt = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof verifyOtt>>,
      TError,
      VerifyOttMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof verifyOtt>>,
  TError,
  VerifyOttMutationVariables,
  TContext
> => {
  return useMutation(getVerifyOttMutationOptions(options), queryClient);
};
export const verifyEmail = (
  verifyRequestEndAction: BodyType<VerifyRequestEndAction>,
  options?: SecondParameter<typeof httpClient>,
  signal?: AbortSignal,
) => {
  return httpClient<AuthResponse>(
    {
      url: `/auth/verify/email_verification`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: verifyRequestEndAction,
      signal,
    },
    options,
  );
};

export const getVerifyEmailMutationKey = () => ["verifyEmail"] as const;

export const getVerifyEmailMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof verifyEmail>>,
    TError,
    VerifyEmailMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof verifyEmail>>,
  TError,
  VerifyEmailMutationVariables,
  TContext
> => {
  const mutationKey = getVerifyEmailMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof verifyEmail>>,
    VerifyEmailMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return verifyEmail(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type VerifyEmailMutationResult = NonNullable<
  Awaited<ReturnType<typeof verifyEmail>>
>;
export type VerifyEmailMutationBody = BodyType<VerifyRequestEndAction>;
export type VerifyEmailMutationError = ErrorType<ErrorResponse>;
export type VerifyEmailMutationVariables = {
  data: BodyType<VerifyRequestEndAction>;
};

export const useVerifyEmail = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof verifyEmail>>,
      TError,
      VerifyEmailMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof verifyEmail>>,
  TError,
  VerifyEmailMutationVariables,
  TContext
> => {
  return useMutation(getVerifyEmailMutationOptions(options), queryClient);
};
export const resendPassword = (
  authSendPasswordResetRequest: BodyType<AuthSendPasswordResetRequest>,
  options?: SecondParameter<typeof httpClient>,
  signal?: AbortSignal,
) => {
  return httpClient<AuthResponse>(
    {
      url: `/auth/send/reset_password`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: authSendPasswordResetRequest,
      signal,
    },
    options,
  );
};

export const getResendPasswordMutationKey = () => ["resendPassword"] as const;

export const getResendPasswordMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resendPassword>>,
    TError,
    ResendPasswordMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resendPassword>>,
  TError,
  ResendPasswordMutationVariables,
  TContext
> => {
  const mutationKey = getResendPasswordMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resendPassword>>,
    ResendPasswordMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return resendPassword(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResendPasswordMutationResult = NonNullable<
  Awaited<ReturnType<typeof resendPassword>>
>;
export type ResendPasswordMutationBody = BodyType<AuthSendPasswordResetRequest>;
export type ResendPasswordMutationError = ErrorType<ErrorResponse>;
export type ResendPasswordMutationVariables = {
  data: BodyType<AuthSendPasswordResetRequest>;
};

export const useResendPassword = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof resendPassword>>,
      TError,
      ResendPasswordMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof resendPassword>>,
  TError,
  ResendPasswordMutationVariables,
  TContext
> => {
  return useMutation(getResendPasswordMutationOptions(options), queryClient);
};
export const resendPhoneVerification = (
  authSendPhoneVerificationRequest: BodyType<AuthSendPhoneVerificationRequest>,
  options?: SecondParameter<typeof httpClient>,
  signal?: AbortSignal,
) => {
  return httpClient<AuthResponse>(
    {
      url: `/auth/send/phone_verification`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: authSendPhoneVerificationRequest,
      signal,
    },
    options,
  );
};

export const getResendPhoneVerificationMutationKey = () =>
  ["resendPhoneVerification"] as const;

export const getResendPhoneVerificationMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resendPhoneVerification>>,
    TError,
    ResendPhoneVerificationMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resendPhoneVerification>>,
  TError,
  ResendPhoneVerificationMutationVariables,
  TContext
> => {
  const mutationKey = getResendPhoneVerificationMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resendPhoneVerification>>,
    ResendPhoneVerificationMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return resendPhoneVerification(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResendPhoneVerificationMutationResult = NonNullable<
  Awaited<ReturnType<typeof resendPhoneVerification>>
>;
export type ResendPhoneVerificationMutationBody =
  BodyType<AuthSendPhoneVerificationRequest>;
export type ResendPhoneVerificationMutationError = ErrorType<ErrorResponse>;
export type ResendPhoneVerificationMutationVariables = {
  data: BodyType<AuthSendPhoneVerificationRequest>;
};

export const useResendPhoneVerification = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof resendPhoneVerification>>,
      TError,
      ResendPhoneVerificationMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof resendPhoneVerification>>,
  TError,
  ResendPhoneVerificationMutationVariables,
  TContext
> => {
  return useMutation(
    getResendPhoneVerificationMutationOptions(options),
    queryClient,
  );
};
export const resendOtt = (
  authSendOttRequest: BodyType<AuthSendOttRequest>,
  options?: SecondParameter<typeof httpClient>,
  signal?: AbortSignal,
) => {
  return httpClient<AuthResponse>(
    {
      url: `/auth/send/mfa_verification`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: authSendOttRequest,
      signal,
    },
    options,
  );
};

export const getResendOttMutationKey = () => ["resendOtt"] as const;

export const getResendOttMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resendOtt>>,
    TError,
    ResendOttMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resendOtt>>,
  TError,
  ResendOttMutationVariables,
  TContext
> => {
  const mutationKey = getResendOttMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resendOtt>>,
    ResendOttMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return resendOtt(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResendOttMutationResult = NonNullable<
  Awaited<ReturnType<typeof resendOtt>>
>;
export type ResendOttMutationBody = BodyType<AuthSendOttRequest>;
export type ResendOttMutationError = ErrorType<ErrorResponse>;
export type ResendOttMutationVariables = { data: BodyType<AuthSendOttRequest> };

export const useResendOtt = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof resendOtt>>,
      TError,
      ResendOttMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof resendOtt>>,
  TError,
  ResendOttMutationVariables,
  TContext
> => {
  return useMutation(getResendOttMutationOptions(options), queryClient);
};
export const resendEmail = (
  authSendEmailVerificationRequest: BodyType<AuthSendEmailVerificationRequest>,
  options?: SecondParameter<typeof httpClient>,
  signal?: AbortSignal,
) => {
  return httpClient<AuthResponse>(
    {
      url: `/auth/send/email_verification`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: authSendEmailVerificationRequest,
      signal,
    },
    options,
  );
};

export const getResendEmailMutationKey = () => ["resendEmail"] as const;

export const getResendEmailMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resendEmail>>,
    TError,
    ResendEmailMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resendEmail>>,
  TError,
  ResendEmailMutationVariables,
  TContext
> => {
  const mutationKey = getResendEmailMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resendEmail>>,
    ResendEmailMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return resendEmail(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResendEmailMutationResult = NonNullable<
  Awaited<ReturnType<typeof resendEmail>>
>;
export type ResendEmailMutationBody =
  BodyType<AuthSendEmailVerificationRequest>;
export type ResendEmailMutationError = ErrorType<ErrorResponse>;
export type ResendEmailMutationVariables = {
  data: BodyType<AuthSendEmailVerificationRequest>;
};

export const useResendEmail = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof resendEmail>>,
      TError,
      ResendEmailMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof resendEmail>>,
  TError,
  ResendEmailMutationVariables,
  TContext
> => {
  return useMutation(getResendEmailMutationOptions(options), queryClient);
};
export const register = (
  authRegisterRequest: BodyType<AuthRegisterRequest>,
  options?: SecondParameter<typeof httpClient>,
  signal?: AbortSignal,
) => {
  return httpClient<AuthResponse>(
    {
      url: `/auth/register`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: authRegisterRequest,
      signal,
    },
    options,
  );
};

export const getRegisterMutationKey = () => ["register"] as const;

export const getRegisterMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof register>>,
    TError,
    RegisterMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof register>>,
  TError,
  RegisterMutationVariables,
  TContext
> => {
  const mutationKey = getRegisterMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof register>>,
    RegisterMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return register(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegisterMutationResult = NonNullable<
  Awaited<ReturnType<typeof register>>
>;
export type RegisterMutationBody = BodyType<AuthRegisterRequest>;
export type RegisterMutationError = ErrorType<ErrorResponse>;
export type RegisterMutationVariables = { data: BodyType<AuthRegisterRequest> };

export const useRegister = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof register>>,
      TError,
      RegisterMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof register>>,
  TError,
  RegisterMutationVariables,
  TContext
> => {
  return useMutation(getRegisterMutationOptions(options), queryClient);
};
export const refresh = (
  options?: SecondParameter<typeof httpClient>,
  signal?: AbortSignal,
) => {
  return httpClient<AuthResponse>(
    { url: `/auth/refresh`, method: "POST", signal },
    options,
  );
};

export const getRefreshMutationKey = () => ["refresh"] as const;

export const getRefreshMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof refresh>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof httpClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof refresh>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = getRefreshMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof refresh>>,
    void
  > = () => {
    return refresh(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RefreshMutationResult = NonNullable<
  Awaited<ReturnType<typeof refresh>>
>;

export type RefreshMutationError = ErrorType<ErrorResponse>;

export const useRefresh = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof refresh>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof refresh>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getRefreshMutationOptions(options), queryClient);
};
export const logout = (
  options?: SecondParameter<typeof httpClient>,
  signal?: AbortSignal,
) => {
  return httpClient<unknown>(
    { url: `/auth/logout`, method: "POST", signal },
    options,
  );
};

export const getLogoutMutationKey = () => ["logout"] as const;

export const getLogoutMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof logout>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof httpClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof logout>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = getLogoutMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof logout>>,
    void
  > = () => {
    return logout(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LogoutMutationResult = NonNullable<
  Awaited<ReturnType<typeof logout>>
>;

export type LogoutMutationError = ErrorType<ErrorResponse>;

export const useLogout = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof logout>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof logout>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getLogoutMutationOptions(options), queryClient);
};
export const login = (
  authLoginRequest: BodyType<AuthLoginRequest>,
  options?: SecondParameter<typeof httpClient>,
  signal?: AbortSignal,
) => {
  return httpClient<AuthResponse>(
    {
      url: `/auth/login`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: authLoginRequest,
      signal,
    },
    options,
  );
};

export const getLoginMutationKey = () => ["login"] as const;

export const getLoginMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof login>>,
    TError,
    LoginMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof login>>,
  TError,
  LoginMutationVariables,
  TContext
> => {
  const mutationKey = getLoginMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof login>>,
    LoginMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return login(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LoginMutationResult = NonNullable<
  Awaited<ReturnType<typeof login>>
>;
export type LoginMutationBody = BodyType<AuthLoginRequest>;
export type LoginMutationError = ErrorType<ErrorResponse>;
export type LoginMutationVariables = { data: BodyType<AuthLoginRequest> };

export const useLogin = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof login>>,
      TError,
      LoginMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof login>>,
  TError,
  LoginMutationVariables,
  TContext
> => {
  return useMutation(getLoginMutationOptions(options), queryClient);
};
export const impersonate = (
  authImpersonateRequest: BodyType<AuthImpersonateRequest>,
  options?: SecondParameter<typeof httpClient>,
  signal?: AbortSignal,
) => {
  return httpClient<AuthResponse>(
    {
      url: `/auth/impersonate`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: authImpersonateRequest,
      signal,
    },
    options,
  );
};

export const getImpersonateMutationKey = () => ["impersonate"] as const;

export const getImpersonateMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof impersonate>>,
    TError,
    ImpersonateMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof impersonate>>,
  TError,
  ImpersonateMutationVariables,
  TContext
> => {
  const mutationKey = getImpersonateMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof impersonate>>,
    ImpersonateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return impersonate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ImpersonateMutationResult = NonNullable<
  Awaited<ReturnType<typeof impersonate>>
>;
export type ImpersonateMutationBody = BodyType<AuthImpersonateRequest>;
export type ImpersonateMutationError = ErrorType<ErrorResponse>;
export type ImpersonateMutationVariables = {
  data: BodyType<AuthImpersonateRequest>;
};

export const useImpersonate = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof impersonate>>,
      TError,
      ImpersonateMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof impersonate>>,
  TError,
  ImpersonateMutationVariables,
  TContext
> => {
  return useMutation(getImpersonateMutationOptions(options), queryClient);
};
